import { createClient } from '@supabase/supabase-js'
import { env } from './env'

const supabaseUrl = env.VITE_SUPABASE_URL
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.localStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
})

// Debug: Log storage contents on initialization
console.log(
  '[Supabase] Initialized with storage keys:',
  Object.keys(window.localStorage).filter((key) => key.includes('supabase')),
)
